import { Box, Button, Fade, Typography } from '@material-ui/core';

const FadeHeader = ({
  headingLabel,
  buttonLabel,
  headingValue,
  classes,
  fadeIn,
  name,
  clickHandler,
}) => (
  <Box className={classes.boxInnerContainer}>
    <Box>
      <Typography className={classes.heading}>{headingLabel}</Typography>
      <span style={{ overflowWrap: 'anywhere', fontSize: '15px' }}>
        {headingValue}
      </span>
    </Box>
    <Fade in={!fadeIn}>
      <Button
        data-testid={`fade-click-${name}`}
        disableRipple
        disableFocusRipple
        size="small"
        className={classes.baseButtoNode}
        onClick={() => clickHandler(name)}
        style={{ padding: '0px', backgroundColor: 'unset' }}
      >
        <Typography
          data-testid={`fade-label-${name}`}
          className={classes.buttonNode}
        >
          {buttonLabel}
        </Typography>
      </Button>
    </Fade>
  </Box>
);

export default FadeHeader;
